import "vite/modulepreload-polyfill";
import "@/assets/styles/main.scss";

import * as Sentry from "@sentry/vue";

import { createApp, DefineComponent, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { createPinia } from "pinia";
import axios from "axios";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";

import scrollTo from "@/directives/scrollTo";
import routeReverse from "@/plugins/route-reverse";
import translations from "@/plugins/translations";

const pages = import.meta.glob("./pages/**/*.vue");

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

createInertiaApp({
    resolve: async (name) => {
        return (await pages[`./pages/${name}.vue`]()) as DefineComponent;
    },
    setup({ el, App, props, plugin }) {
        const pinia = createPinia();
        const vueApp = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(pinia)
            .use(FloatingVue)
            .use(routeReverse)
            .use(translations);

        if (props.initialPage.props.envSentryDsn) {
            Sentry.init({
                app: vueApp,
                dsn: props.initialPage.props.envSentryDsn as string,
                integrations: [new Sentry.BrowserTracing()],
                environment: props.initialPage.props.envEnvironment as string,
                release: props.initialPage.props.envReleaseReference as string,
            });
        }

        vueApp.directive("scroll-to", scrollTo);

        vueApp.mount(el);
    },
    progress: {
        color: "#5fcced",
    },
});
